.form-field {
	margin-bottom: 1.5rem;
	width: 100%;
}

.label-container {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.text-input,
.select {
	margin: 2px 0px;
	padding: 0.5rem;
	border-width: 3px;
	border-style: solid;
	border-color: var(--input-border-color);
	border-radius: var(--border-radius, 0.5rem);
	font-size: 1rem;
	line-height: 1.2;
	letter-spacing: 0.05rem;
	width: 100%;
	background-color: var(--white, #ececec);

	&:focus-visible {
		border-width: 5px;
		outline: 2px solid transparent;
		margin: 0px;
	}

	&:focus {
		border-color: var(--input-border-focus-color);
	}
}

.submit {
	background-color: var(--btn-primary-bg);
	color: var(--btn-primary-color);

	&:hover {
		background-color: var(--btn-primary-hover-bg);
	}

	&:disabled {
		background-color: var(--btn-primary-disabled-bg);
	}
}

.secondary {
	background-color: var(--btn-secondary-bg);
	color: var(--btn-secondary-color);

	&:hover {
		background-color: var(--btn-secondary-hover-bg);
	}

	&:disabled {
		background-color: var(--btn-secondary-disabled-bg);
	}
}
